import { render } from "./ConfirmDeleteModal.vue?vue&type=template&id=55d7c8da&scoped=true&ts=true&lang=pug"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmDeleteModal.vue?vue&type=style&index=0&id=55d7c8da&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d7c8da"]])

export default __exports__